module.exports = __webpack_public_path__ + "static/media/learn-not-found.cf4209c5.png";